import { GET_INFO_FAIL } from 'actions/currentOrganization';
import { LOAD_FAIL } from 'actions/featureToggles';
import { GET_PERSON_FAIL } from 'actions/loggedInUser';
import { GET_NAV_PLANS_FAIL } from 'actions/plans';
import {
  GET_ACTIVE_ALERTS_COUNT_SUCCESS,
  UPDATE_NAVIGATION,
  NAV_PAGE_DIRTY,
} from 'actions/navigation';

export const defaultState = {
  menuId: window.XM_MENU_ID || '',
  subMenuId: window.XM_SUB_MENU_ID || '',
  helpId: window.XM_HELP_ID || '',
  isDirty: false,
  chickenExitMessageId: null,
  xmApiCallError: false,
  activeAlertsCount: 0,
};

export default function navigation(state = defaultState, action) {
  if (!action) {
    return state;
  }
  const { type, payload } = action;
  if (payload) {
    switch (type) {
      case UPDATE_NAVIGATION:
        return {
          ...state,
          ...payload,
        };
      case GET_ACTIVE_ALERTS_COUNT_SUCCESS:
        return {
          ...state,
          activeAlertsCount: payload.count,
        };
      case NAV_PAGE_DIRTY:
        return {
          ...state,
          ...payload,
        };
      case GET_PERSON_FAIL:
      case GET_INFO_FAIL:
      case LOAD_FAIL:
      case GET_NAV_PLANS_FAIL: {
        return {
          ...state,
          xmApiCallError: true,
        };
      }
      default:
        return state;
    }
  }
  return state;
}
